module.exports = __webpack_public_path__ + "static/media/policy.220731f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/SRA/policy.png
// module id = 3536
// module chunks = 3